import React, { useState } from "react";
import Input from "../../../../../widget/common/form/Input";
import { SettingsPersonalSecurityContextImport } from "../../../../../provider/settings/security/personal_security/SettingsPersonalSecurityContextProvider";
import PhoneNumber from "../../../../../widget/common/form/PhoneNumber";
import { CountryCodeList } from "../../../../../model/country_code/CountryCodeModel";
import { useDispatch } from "react-redux";
import { selectedCountryCodeTextField } from "../../../../../libraries/state_reducers/country_code/CountryCodeReducer";

export const SecurityPasswordField = () => {
  const { passwords, handleOnChange, passwordsValidate, validateStatus } =
    SettingsPersonalSecurityContextImport();
  const [showText, setShowText] = useState<boolean>(false);

  const suffixHandleClick = () => {
    setShowText(!showText);
  };
  return (
    <Input
      type={`${showText ? "text" : "password"}`}
      name="new_password"
      handleOnChange={handleOnChange}
      value={passwords.password}
      validate={true}
      label="new_password"
      suffixType="icon"
      suffixIcon={`${showText ? "eye_open" : "eye_close"}`}
      suffixHandleClick={suffixHandleClick}
      error={validateStatus ? !passwordsValidate.password : false}
      showPassHint={true}
    />
  );
};

export const SecurityPasswordConfirmField = () => {
  const { passwords, handleOnChange, passwordsValidate, validateStatus } =
    SettingsPersonalSecurityContextImport();
  const [showText, setShowText] = useState<boolean>(false);

  const suffixHandleClick = () => {
    setShowText(!showText);
  };

  return (
    <Input
      type={`${showText ? "text" : "password"}`}
      name="password_confirm"
      handleOnChange={handleOnChange}
      value={passwords.password_confirm}
      validate={true}
      label="confirm_new_password"
      suffixType="icon"
      suffixIcon={`${showText ? "eye_open" : "eye_close"}`}
      suffixHandleClick={suffixHandleClick}
      error={validateStatus ? !passwordsValidate.confirm : false}
      showPassHint={true}
    />
  );
};

export const SecurityEmailField = () => {
  const { emails, handleOnChange, emailsValidate, validateStatus } =
    SettingsPersonalSecurityContextImport();
  return (
    <Input
      type="email"
      name="new_email"
      handleOnChange={handleOnChange}
      value={emails.email}
      validate={true}
      label="new_email"
      error={validateStatus ? !emailsValidate.email : false}
    />
  );
};

export const SecurityEmailConfirmField = () => {
  const { emails, handleOnChange, emailsValidate, validateStatus } =
    SettingsPersonalSecurityContextImport();

  return (
    <Input
      type="email"
      name="confirm_new_email"
      handleOnChange={handleOnChange}
      value={emails.email_confirm}
      validate={true}
      label="confirm_new_email"
      error={validateStatus ? !emailsValidate.confirm : false}
    />
  );
};

export const SecurityPhoneField = () => {
  const dispatch = useDispatch();
  const {
    phone,
    handleOnChange,
    validateStatus,
    phoneValidate,
    applyCountryCode,
  } = SettingsPersonalSecurityContextImport();

  const applyCode = (countryCodeDetail: CountryCodeList) => {
    applyCountryCode(countryCodeDetail);
  };

  const handleChangePrefix = () => {
    dispatch(selectedCountryCodeTextField("phone_number_new"));
  };

  return (
    <PhoneNumber
      name="phone_number_new"
      handleOnChange={handleOnChange}
      handleChangePrefix={handleChangePrefix}
      value={phone.phone.phone_number}
      code={phone.phone.phone_code}
      label="new_phone_number"
      callback={applyCode}
      validate={true}
      error={validateStatus ? !phoneValidate.phone : false}
    />
  );
};

export const SecurityPhoneConfirmField = () => {
  const dispatch = useDispatch();
  const {
    phone,
    handleOnChange,
    validateStatus,
    phoneValidate,
    applyCountryCode,
  } = SettingsPersonalSecurityContextImport();

  const applyCode = (countryCodeDetail: CountryCodeList) => {
    applyCountryCode(countryCodeDetail);
  };

  const handleChangePrefix = () => {
    dispatch(selectedCountryCodeTextField("phone_number_new_confirm"));
  };

  return (
    <PhoneNumber
      name="phone_number_new_confirm"
      handleOnChange={handleOnChange}
      handleChangePrefix={handleChangePrefix}
      value={phone.phone_confirm.phone_number}
      code={phone.phone_confirm.phone_code}
      label="confirm_new_phone_number"
      callback={applyCode}
      validate={true}
      error={validateStatus ? !phoneValidate.phone_confirm : false}
    />
  );
};
